/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { EmailAddressValidity } from './';
import {
    EmailAddressValidityFromJSON,
    EmailAddressValidityFromJSONTyped,
    EmailAddressValidityToJSON,
} from './';

/**
 * 
 * @export
 * @interface EmailAddressValidityResponse
 */
export interface EmailAddressValidityResponse {
    /**
     * 
     * @type {EmailAddressValidity}
     * @memberof EmailAddressValidityResponse
     */
    validity?: EmailAddressValidity;
}

/**
 * Check if a given object implements the EmailAddressValidityResponse interface.
 */
export function instanceOfEmailAddressValidityResponse(value: object): value is EmailAddressValidityResponse {
    return true;
}

export function EmailAddressValidityResponseFromJSON(json: any): EmailAddressValidityResponse {
    return EmailAddressValidityResponseFromJSONTyped(json, false);
}

export function EmailAddressValidityResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmailAddressValidityResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'validity': json['validity'] == null ? undefined : EmailAddressValidityFromJSON(json['validity']),
    };
}

export function EmailAddressValidityResponseToJSON(value?: EmailAddressValidityResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'validity': EmailAddressValidityToJSON(value['validity']),
    };
}

